module.exports = __webpack_public_path__ + "media/src/images/mails/aecb36-1b9c3991735e2b82bebc99dc4536a0a6.png";